import { useState } from "react";
import Button from "../../ui/Button";
import { useLanguage } from "../../../i18n/LanguageContext";

export default function ContactForm() {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSending, setIsSending] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const validEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  const validPhone = (value) => /^\d{10}$/.test(value);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const cleanValue = name === "phone" ? value.replace(/[^\d]/g, "") : value;

    setFormData((prev) => ({
      ...prev,
      [name]: cleanValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setSuccessMessage("");
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = t.contact.errors.nameRequired;
    }

    if (!formData.phone.trim()) {
      newErrors.phone = t.contact.errors.phoneRequired;
    } else if (!validPhone(formData.phone.trim())) {
      newErrors.phone = t.contact.errors.phoneInvalid;
    }

    if (!formData.email.trim()) {
      newErrors.email = t.contact.errors.emailRequired;
    } else if (!validEmail(formData.email.trim())) {
      newErrors.email = t.contact.errors.emailInvalid;
    }

    if (!formData.message.trim()) {
      newErrors.message = t.contact.errors.messageRequired;
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    setIsSending(true);

    try {
      const response = await fetch("/api/inquiries", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          full_name: formData.name,
          phone: formData.phone,
          email: formData.email,
          message: formData.message,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage(t.contact.success);
        setFormData({ name: "", phone: "", email: "", message: "" });
      } else {
        setSuccessMessage("حدث خطأ، حاول مرة ثانية");
      }
    } catch (err) {
      setSuccessMessage("تعذّر الاتصال بالسيرفر");
    }

    setIsSending(false);
  };

  return (
    <section className="contact-card contact-form-card">
      <h2 className="section-title">{t.contact.formTitle}</h2>
      <p className="section-desc">{t.contact.formSubtitle}</p>

      <form className="contact-form" onSubmit={handleSubmit}>
        <input
          className="contact-input"
          type="text"
          name="name"
          placeholder={t.contact.placeholders.name}
          value={formData.name}
          onChange={handleChange}
        />
        {errors.name && <small className="field-error">{errors.name}</small>}

        <input
          className="contact-input"
          type="text"
          name="phone"
          placeholder={t.contact.placeholders.phone}
          value={formData.phone}
          onChange={handleChange}
        />
        {errors.phone && <small className="field-error">{errors.phone}</small>}

        <input
          className="contact-input"
          type="email"
          name="email"
          placeholder={t.contact.placeholders.email}
          value={formData.email}
          onChange={handleChange}
        />
        {errors.email && <small className="field-error">{errors.email}</small>}

        <textarea
          className="contact-input contact-textarea"
          name="message"
          placeholder={t.contact.placeholders.message}
          value={formData.message}
          onChange={handleChange}
          rows="6"
        />
        {errors.message && (
          <small className="field-error">{errors.message}</small>
        )}

        <Button
          text={isSending ? t.contact.button.sending : t.contact.button.send}
          type="submit"
          className="submit-btn"
        />

        {successMessage && <div className="success-box">{successMessage}</div>}
      </form>
    </section>
  );
}
